var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"admin-layout"}},[_c('Header'),_c('Sidebar'),_c('div',{staticClass:"content-admin"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }